/** @jsx jsx */
import { jsx } from "theme-ui"
import PropTypes from "prop-types"

const Bars = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="64"
    height="64"
    fill="none"
    viewBox="0 0 64 64"
    className={className}
  >
    <path
      fill="currentColor"
      d="M6 10a3 3 0 013-3h47a3 3 0 110 6H9a3 3 0 01-3-3zm0 21a3 3 0 013-3h47a3 3 0 013 3v1a3 3 0 01-3 3H9a3 3 0 01-3-3v-1zm0 22a3 3 0 013-3h47a3 3 0 110 6H9a3 3 0 01-3-3z"
    ></path>
  </svg>
)

Bars.propTypes = {
  className: PropTypes.string,
}

export default Bars
